<script>
    import LoginFooterIcons from "./login-footer-icons.vue";
    import TextField from "../common/text-field.vue";
    import Loading from "../common/loading.vue";
    import LoginBanner from "./login-banner.vue";
    import LoginWindowFooter from "./login-window-footer.vue";
    import LoginContainer from "./login-container.vue";
    import LoginWindow from "./login-window.vue";
    import LoginEmailField from "./login-email-field.vue";
    import LoginForm from "./login-form.vue";
    import LoginPasswordField from "./login-password-field.vue";
    import LoginSubmitButton from "./login-submit-button.vue";
    import LoginSocials from "./login-socials.vue";

    export default {
        name: "login",
        components: {
            LoginSocials,
            LoginSubmitButton,
            LoginPasswordField,
            LoginForm,
            LoginEmailField,
            LoginWindow, LoginContainer, LoginWindowFooter, LoginBanner, Loading, TextField, LoginFooterIcons
        },
        props: {
            licenseServerActiveString: String,
            demoRegistrationActiveString: String,
            registerUrl: String,
            demoUrl: String,
            pwUrl: String,
            loginUrl: String,
            versionText: String,
            userInactiveError: String,
            credentialsError: String,
            socialError: String,
            csrfToken: String,
            previousEmail: String,
            availableSocialLogins: {type: String, default: ''}
        },
        data() {
            return {
                passwordValid: false,
                emailValid: false,
                loading: false,
            }
        },
        provide() {
            return {
                appKey: this.appKey,
            }
        },
        computed: {
            translations() {
                return {
                    demo: Lang.langGet('Demo'),
                    register: Lang.langGet('Register'),
                    forgotPw: Lang.langGet('Forgot password'),
                    email: Lang.langGet('Email address'),
                    password: Lang.langGet('Password'),
                    login: Lang.langGet('Login'),
                    loginMicrosoft: Lang.langGet('Login with Microsoft'),
                    loginGoogle: Lang.langGet('Login with Google'),
                }
            },
            licenseServerActive() {
                return this.licenseServerActiveString.includes('1');
            },
            demoRegistrationActive() {
                return this.demoRegistrationActiveString.includes('1');
            },
            hasErrors() {
                return this.userInactiveError || this.credentialsError || this.socialError;
            },
            availableSocialsArray() {
                return this.availableSocialLogins
                    .split(',')
                    .map(s => s.trim())
                    .filter(Boolean);
            },
        },
        methods: {
            handleSubmit() {
                this.loading = true;
            },
            handleValidity(prop, value) {
                this[`${prop}Valid`] = value;
            },
        }
    }
</script>

<template>
    <login-container>
        <loading :loading="loading"/>
        <login-window>
            <login-banner/>

            <div v-if="hasErrors">
                <div class="login-error" v-if="credentialsError">{{ credentialsError }}</div>
                <div class="login-error" v-if="userInactiveError">{{ userInactiveError }}</div>
                <div class="login-error" v-if="socialError">{{ socialError }}</div>
            </div>

            <login-form :url="loginUrl">
                <input type="hidden" name="_token" :value="csrfToken" autocomplete="off"/>
                <login-email-field @valid="handleValidity" :value="previousEmail"/>
                <login-password-field @valid="handleValidity"/>
                <login-submit-button @click="handleSubmit" :disabled="!emailValid || !passwordValid">
                    {{ translations.login }}
                </login-submit-button>
                <login-socials :logins="availableSocialsArray"/>
            </login-form>

            <login-window-footer :versionText="versionText">
                <a :href="pwUrl">{{ `${translations.forgotPw}?` }}</a>
                <a v-if="licenseServerActive" :href="registerUrl">{{ translations.register }}</a>
                <a v-if="demoRegistrationActive" :href="demoUrl">{{ translations.demo }}</a>
            </login-window-footer>
        </login-window>
        <login-footer-icons url="https://easescreen.com/"/>
    </login-container>
</template>

<style>
.login-error {
    color: #ff5252;
}
</style>
